module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Browse"
  }, [_c('div', {
    staticClass: "Browse-wrapper"
  }, [_c('section', {
    staticClass: "Browse-content"
  }, [_c('div', {
    staticClass: "Browse-viewer"
  }, [_c('toolbar', {
    attrs: {
      "page": _vm.page,
      "zoomLevel": _vm.zoomLevel,
      "zoomIn": _vm.zoomIn,
      "zoomOut": _vm.zoomOut,
      "fitTo": _vm.fitTo,
      "prevPage": _vm.prevPage,
      "nextPage": _vm.nextPage,
      "showInks": _vm._showInks,
      "showOverview": _vm._showOverview,
      "showOverprint": _vm._showOverprint,
      "toggleBoxes": _vm._toggleBoxes,
      "toggleRulers": _vm._toggleRulers,
      "set-units": _vm.setUnits
    }
  }), _vm._v(" "), _c('pdf', {
    ref: "pdf",
    attrs: {
      "url": _vm.url,
      "zoom": _vm.zoom,
      "page": _vm.page,
      "unit": _vm.unit,
      "showOverview": _vm.showOverview,
      "showInks": _vm.showInks,
      "showBoxes": _vm.showBoxes,
      "showRulers": _vm.showRulers,
      "changePage": _vm.changePage,
      "zoomEnd": _vm.zoomEnd,
      "showOverprint": _vm.showOverprint
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade folder-modal",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "id": "folder-modal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newFolderName),
      expression: "newFolderName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newFolderName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newFolderName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.handleCloseFolderModal()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": !_vm.newFolderName
    },
    on: {
      "click": function($event) {
        return _vm.createFolder()
      }
    }
  }, [_vm._v("Create\n\t\t\t\t\t\t\tFolder\n\t\t\t\t\t\t")])])])])]), _vm._v(" "), _c('upload', {
    attrs: {
      "show": _vm.showModal
    },
    on: {
      "uploadcomplete": _vm.uploadComplete
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Upload Files")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8a2e92c4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Browse.vue
// module id = 424
// module chunks = 1